/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BaseModal, Button } from 'yankees-react-utils';
import { Form } from 'react-bootstrap';
import { useOktaAuth } from '@okta/okta-react';
import { VideoSearch } from '../../data';

const SavedSearchModal = ({ showModal, setShowModal, modalContainer, searchForm, filter, savedSearch, onUpdate, onCreate }) => {
    const { t: translate } = useTranslation();
    const { authState: { accessToken } } = useOktaAuth();

    const [name, setName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (savedSearch) {
            setName(savedSearch.Name);
        }
    }, [savedSearch]);

    const submit = async () => {
        try {
            setIsLoading(true);

            if (savedSearch) {
                const updatedSearch = {
                    ...savedSearch,
                    Name: name,
                };
                await VideoSearch.update(accessToken, savedSearch.VideoSearchID, updatedSearch);
                onUpdate(updatedSearch);
            } else {
                const newSearch = {
                    ...searchForm,
                    Filters: JSON.stringify(filter),
                    Name: name,
                };
                await VideoSearch.create(accessToken, newSearch);
                onCreate(newSearch);
            }
            setShowModal(false);
            setName('');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <BaseModal
            show={showModal}
            onHide={() => setShowModal(false)}
            container={modalContainer}
        >
            <BaseModal.Header>
                {savedSearch ? translate('sections.video-playlists.update-search') : translate('sections.video-playlists.save-new-search') }
            </BaseModal.Header>
            <BaseModal.Body>
                <Form.Group>
                    <Form.Label className="mb-1">{translate('sections.video-playlists.name')}</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={translate('sections.video-playlists.enter-search-name')}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Form.Group>
            </BaseModal.Body>
            <BaseModal.Footer>
                <Button onClick={() => setShowModal(false)}>{translate('common.cancel')}</Button>
                <Button variant="primary" onClick={submit} disabled={!name || isLoading}>{translate('common.save')}</Button>
            </BaseModal.Footer>
        </BaseModal>
    );
};

SavedSearchModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    modalContainer: PropTypes.any.isRequired,
    searchForm: PropTypes.object,
    filter: PropTypes.object,
    savedSearch: PropTypes.object,
    onUpdate: PropTypes.func,
    onCreate: PropTypes.func,
};

SavedSearchModal.defaultProps = {
    searchForm: null,
    savedSearch: null,
    filter: {},
    onUpdate: () => {},
    onCreate: () => {},
};

export default SavedSearchModal;
